import React from 'react';
import { motion } from 'framer-motion';
import { Users, Award, Globe, Clock, Briefcase, Search, GraduationCap, FileText, ClipboardCheck, Network, Building2 } from 'lucide-react';
export function AboutPage() {
  return <div className="pt-20" data-id="element-99" data-mp="53z7tyr8zbi3">
      {/* Hero */}
      <section className="bg-navy-900 text-white py-20" data-id="element-100" data-mp="78sjdn9ojxq">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-101" data-mp="6gyi79biu9k">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-serif font-bold mb-6" data-id="element-102" data-mp="3rdthmrtrhhs4">
            About Continuum Talent Solutions
          </motion.h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-103" data-mp="3dflj4fh2u8eu">
            We are more than just recruiters. We are career architects dedicated
            to building the future of work, one placement at a time.
          </p>
        </div>
      </section>

      {/* About Continuum Talent Solutions — Company Overview */}
      <section className="py-20 bg-white" data-id="element-104" data-mp="2jvtv1y2jevek">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105" data-mp="2jwlqn8w4wt4u">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-106" data-mp="25xdoc74od4wf">
            <span className="inline-block text-gold-600 font-semibold tracking-[0.25em] uppercase text-xs mb-4" data-id="element-107" data-mp="2atue15rivrbm">
              Who We Are
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-6" data-id="element-108" data-mp="2ymkn9781jwi7">
              About Continuum Talent Solutions
            </h2>
            <div className="w-16 h-0.5 bg-gold-500 mx-auto mb-8" data-id="element-109" data-mp="2otc2tl4tj4kz" />
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-110" data-mp="2tt8bhxognk6v">
              At Continuum Talent Solutions, we connect exceptional talent with
              forward-thinking organizations across diverse industries
              worldwide. We are a people-driven recruitment and workforce
              solutions company committed to helping businesses build
              high-performing teams while empowering professionals to achieve
              meaningful career success.
            </p>
          </div>

          {/* Body paragraphs */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20" data-id="element-111" data-mp="3m60pg4bcoms5">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="border-l-4 border-gold-500 pl-6" data-id="element-112" data-mp="3h7petrd8e88v">
              <p className="text-gray-600 leading-relaxed" data-id="element-113" data-mp="2yi9dx2xmwdrx">
                Our expertise extends beyond traditional recruitment. We
                specialize in talent acquisition, executive search, resume and
                LinkedIn optimization, career consulting, interview preparation,
                workforce documentation support, and strategic hiring solutions
                tailored to the evolving demands of today's global marketplace.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="border-l-4 border-gold-500 pl-6" data-id="element-114" data-mp="1e08920ntn6g3">
              <p className="text-gray-600 leading-relaxed" data-id="element-115" data-mp="v8fsj5pxvdp9">
                With a strong understanding of industry trends and employer
                expectations, we partner with companies to identify top-tier
                professionals who drive innovation, productivity, and long-term
                growth. For job seekers, we provide personalized career support
                designed to increase visibility, strengthen professional
                branding, and unlock new opportunities.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="border-l-4 border-gold-500 pl-6" data-id="element-116" data-mp="255dwy2z5bmxe">
              <p className="text-gray-600 leading-relaxed" data-id="element-117" data-mp="31xhfmx3sggop">
                At Continuum Talent Solutions, we believe recruitment is more
                than filling positions — it is about building lasting
                relationships, creating career pathways, and bridging the gap
                between talent and opportunity.
              </p>
            </motion.div>
          </div>

          {/* What We Deliver */}
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12" data-id="element-118" data-mp="3e90d00tun5de">
            <div className="text-center mb-12" data-id="element-119" data-mp="3j722p4ls62xu">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy-900 mb-3" data-id="element-120" data-mp="3j5qtuqdha4zv">
                What We Deliver
              </h3>
              <div className="w-12 h-0.5 bg-gold-500 mx-auto" data-id="element-121" data-mp="39h8vefso89ze" />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-122" data-mp="39f5u2zm2iufd">
              {[{
              icon: Briefcase,
              label: 'Executive & Professional Recruitment'
            }, {
              icon: Search,
              label: 'Talent Sourcing & Acquisition'
            }, {
              icon: GraduationCap,
              label: 'Career Coaching & Job Search Support'
            }, {
              icon: FileText,
              label: 'Resume Writing & LinkedIn Optimization'
            }, {
              icon: ClipboardCheck,
              label: 'Workforce & Documentation Assistance'
            }, {
              icon: Globe,
              label: 'Remote & Global Hiring Solutions'
            }, {
              icon: Building2,
              label: 'Employer Branding & Staffing Support'
            }, {
              icon: Network,
              label: 'Strategic Hiring Solutions'
            }].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="flex items-center gap-4 bg-white p-5 rounded-lg shadow-sm border border-gray-100" data-id="element-123" data-mp="27m5so9e6eve0" data-mpi={index}>
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-navy-900 flex items-center justify-center" data-id="element-124" data-mp="37nsshh5ovds4">
                    <item.icon className="h-5 w-5 text-gold-500" data-id="element-125" data-mp="3gme8p5nougpq" />
                  </div>
                  <span className="text-gray-800 font-medium text-sm leading-snug" data-id="element-126" data-mp="3llquro6qjjr9">
                    {item.label}
                  </span>
                </motion.div>)}
            </div>
          </div>

          {/* Values + tagline */}
          <div className="mt-16 max-w-4xl mx-auto text-center" data-id="element-127" data-mp="3vcvbasc27co7">
            <p className="text-gray-600 leading-relaxed mb-8 text-lg" data-id="element-128" data-mp="45r1jpoj5cc3">
              We are dedicated to{' '}
              <span className="text-navy-900 font-semibold" data-id="element-129" data-mp="87m570txo1t1">
                professionalism, integrity, innovation, and results
              </span>{' '}
              — helping both organizations and professionals thrive in a
              competitive world.
            </p>
            <div className="inline-block" data-id="element-130" data-mp="ti1eo4oxfc6c">
              <p className="text-2xl md:text-3xl font-serif italic text-navy-900 mb-2" data-id="element-131" data-mp="tgzunapxnfch">
                Continuum Talent Solutions
              </p>
              <p className="text-gold-600 font-medium tracking-wider text-sm uppercase" data-id="element-132" data-mp="13fyzsjbhosuq">
                Connecting Talent with Opportunity
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50" data-id="element-133" data-mp="asmiank6rb8a">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-134" data-mp="pg7ia8lrkubz">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-135" data-mp="phiki3zk9u0z">
            <div data-id="element-136" data-mp="kophbkjqqtr0">
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Team collaboration" className="rounded-lg shadow-xl" data-id="element-137" data-mp="ko6aozzjjrsa" />
            </div>
            <div data-id="element-138" data-mp="23n44bctx2beg">
              <h2 className="text-3xl font-serif font-bold text-navy-900 mb-6" data-id="element-139" data-mp="23mkpw63h6556">
                Our Mission
              </h2>
              <p className="text-gray-600 mb-8 text-lg leading-relaxed" data-id="element-140" data-mp="28gox8qgnkf6s">
                To empower professionals to achieve their full potential and
                assist organizations in building world-class teams. We believe
                that the right job can transform a life, and the right employee
                can transform a business.
              </p>

              <h2 className="text-3xl font-serif font-bold text-navy-900 mb-6" data-id="element-141" data-mp="2rd7yktl7syss">
                Our Vision
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-142" data-mp="2dgb84t90djcf">
                To be the global standard in recruitment excellence, known for
                integrity, speed, and the quality of our connections.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Grid */}
      <section className="bg-white py-20" data-id="element-143" data-mp="1qnu9s23yl5h3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144" data-mp="1qovmsc4jc21g">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-145" data-mp="1vn6t4cvmfuex">
            {[{
            icon: Users,
            label: 'Expert Recruiters',
            value: '50+'
          }, {
            icon: Award,
            label: 'Awards Won',
            value: '15'
          }, {
            icon: Globe,
            label: 'Global Offices',
            value: '6'
          }, {
            icon: Clock,
            label: 'Years Active',
            value: '12'
          }].map((stat, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-sm text-center" data-id="element-146" data-mp="12y9p9es5q05p" data-mpi={index}>
                <stat.icon className="h-8 w-8 text-gold-500 mx-auto mb-4" data-id="element-147" data-mp="2xbr3gb6o9ko2" />
                <div className="text-3xl font-bold text-navy-900 mb-2" data-id="element-148" data-mp="2x9wp5fpwoqsy">
                  {stat.value}
                </div>
                <div className="text-gray-600" data-id="element-149" data-mp="hnc4jkh87h0q">{stat.label}</div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section id="team" className="py-20 scroll-mt-24" data-id="element-150" data-mp="vgjwjd97yeiy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151" data-mp="qmpd8axj01ke">
          <div className="text-center mb-16" data-id="element-152" data-mp="15ceioicnirqh">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-153" data-mp="15bbw2mmd3bgd">
              Meet Our Team
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-154" data-mp="10fwf3lt24zfq">
              Experienced professionals dedicated to transforming careers and
              connecting talent with opportunity.
            </p>
          </div>

          {/* Founder — Featured */}
          <div className="flex flex-col items-center mb-20" data-id="element-155" data-mp="3g5hbw4d7fig3">
            <div className="relative group" data-id="element-156" data-mp="3b5uzty94488v">
              {/* Decorative ring */}
              <div className="absolute -inset-3 rounded-full border-2 border-gold-500/40 animate-pulse" data-id="element-157" data-mp="1f2ghmst4vgs3" />
              <div className="absolute -inset-6 rounded-full border border-gold-500/20" data-id="element-158" data-mp="1k1jkq7pjzcxf" />
              {/* Photo circle */}
              <div className="relative w-48 h-48 rounded-full overflow-hidden border-4 border-gold-500 shadow-2xl" data-id="element-159" data-mp="1p0ef86wvupxd">
                <img src="https://cdn.magicpatterns.com/uploads/qdYs7LErqNJjHmXmoY5vKY/1636567611328_(1).jpg" alt="Michael Johnson — Founder & CEO" className="w-full h-full object-cover" data-id="element-160" data-mp="1t311lsasbin6" />
              </div>
              {/* Gold badge */}
              <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 bg-gold-500 text-white text-xs font-bold px-4 py-1 rounded-full shadow-md tracking-wider uppercase whitespace-nowrap" data-id="element-161" data-mp="27rnpiieh9iq0">
                Founder & CEO
              </div>
            </div>
            <div className="mt-10 text-center" data-id="element-162" data-mp="2lqdoy4orruhj">
              <h3 className="text-2xl font-serif font-bold text-navy-900 mb-1" data-id="element-163" data-mp="2lr6lkcu0l3ly">
                Michael Johnson
              </h3>
              <p className="text-gold-600 font-semibold mb-3" data-id="element-164" data-mp="54gtl2ouhcqm">
                Founder & Chief Executive Officer
              </p>
              <p className="text-gray-500 max-w-md mx-auto text-sm leading-relaxed" data-id="element-165" data-mp="13wu3sgstx1b">
                Michael founded Continuum Talent Solutions to create more
                meaningful connections between exceptional professionals and the
                teams that need them most.
              </p>
            </div>
          </div>

          {/* Team Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10" data-id="element-166" data-mp="k1rc2vzwnivu">
            {[{
            img: 'https://cdn.magicpatterns.com/uploads/gZ8sRYjABDAWW9NXjHvXZx/1518079433608.jpg',
            name: 'Mitch B',
            role: 'Retained Executive Search Consultant'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/qgHzMdd3A2XcVSTqC8WZwX/1677800762668.jpg',
            name: 'Adam Cray',
            role: 'Executive Recruiter'
          }, {
            img: 'https://cdn.magicpatterns.com/uploads/b21mh5k9WS1NLv2czZhqk6/1715370377328.jpg',
            name: 'Abel (AJ) Davila',
            role: 'Executive Search Consultant'
          }].map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex flex-col items-center text-center" data-id="element-167" data-mp="1aza4tuesxb6b" data-mpi={index}>
                <div className="relative mb-5" data-id="element-168" data-mp="1ypw9dbplkdbk">
                  <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-white shadow-xl ring-2 ring-navy-900/10" data-id="element-169" data-mp="1yqpek88wqurl">
                    <img src={member.img} alt={member.name} className="w-full h-full object-cover" data-id="element-170" data-mp="242upfkcshzvz" />
                  </div>
                </div>
                <h3 className="text-lg font-bold text-navy-900 mb-1" data-id="element-171" data-mp="2cvy1bo7se4oi">
                  {member.name}
                </h3>
                <p className="text-gold-600 font-medium text-sm" data-id="element-172" data-mp="1p5u5w44r5b8l">
                  {member.role}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}